const staticSegmentData: Record<string, string> = {};

const setStaticSegmentData = (key: string, value: string) => {
  staticSegmentData[key] = value;
};

export { staticSegmentData, setStaticSegmentData };
